// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZD84","toggle":"styles_toggle__2mklm","preview":"styles_preview__3jj3E"};